import {DiamondNode, DiamondNodeModel} from '@logicflow/core';

class NodeJudgeModel extends DiamondNodeModel {
    getNodeStyle() {
        const style = super.getNodeStyle();
        const properties = this.properties;

        style.strokeWidth = 1
        if (properties.finish === true || properties.current === true) {
            style.strokeWidth = 3;
        }

        if (properties.skin_fill) {
            style.fill = properties.skin_fill;
        }

        if (properties.style_fill) {
            style.fill = properties.style_fill
        }

        if (properties.style_stroke) {
            style.stroke = properties.style_stroke
        }

        if (properties.rx) {
            style.rx = properties.rx
        }
        if (properties.ry) {
            style.ry = properties.ry
        }
        return style;
    }

    getTextStyle() {
        const style = super.getTextStyle();

        const properties = this.properties;
        if (properties.style_color) {
            style.color = properties.style_color
        }
        return style;
    }
}

class PrcDiamondNode extends DiamondNode {
}

export default {
    type: 'node_judge',
    view: PrcDiamondNode,
    model: NodeJudgeModel,
};